// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const initNewProductsSlider = () => {
    const sliders = document.querySelectorAll('.block-products-grid__items');
    sliders.forEach(slider => {
        const swiper = new Swiper(slider, {
            navigation: {
                nextEl: slider.closest('.block-products-grid').querySelector('.block-products-grid__btn-next'),
                prevEl: slider.closest('.block-products-grid').querySelector('.block-products-grid__btn-prev'),
            },
            spaceBetween: 10,
            slidesPerView: 4,
            modules: [Navigation, Pagination],
            speed: 1000,
            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    pagination: {
                        el: slider.closest('.block-products-grid').querySelector('.block-products-grid__pagination'),
                        type: 'bullets',
                        clickable: true,
                    },
                },
                768: {
                    slidesPerView: 2.4,
                },
                1024: {
                    slidesPerView: 4,
                },
            }
        });

        return swiper;
    });
};

initNewProductsSlider();
export default initNewProductsSlider;
